import { useLocalStorageState } from 'ahooks'
import { Popup } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import { NavLink } from './lib/Navigation'
import general from './general'
import BoxColor from './BoxType'
var packageJson = require('../package.json')

export default function Update() {

  const [visible, setVisible] = useState(false)
  const [newversion, setNewVersion] = useState('')
  const [update_content, set_update_content] = useState('')
  const [web_forceupdate, set_web_forceupdate] = useState(false)
  const [version, setVersion] = useLocalStorageState('version', '245.1.1')

  const getData = () => {
    general.axios.post('/base/common/updateApp').then(res => {
      const data = res.data.data
      set_update_content(data.update_content)
      setNewVersion(data.version_name)
      set_web_forceupdate(data.web_forceupdate)
    })
  }

  const compareVersions = (local, online) => {
    // 检查版本号格式
    const versionRegex = /^\d+\.\d+\.\d+$/;
    if (!versionRegex.test(local) || !versionRegex.test(online)) {
      return false;
    }

    // 分割版本号为数组
    const localParts = local.split('.').map(Number);
    const onlineParts = online.split('.').map(Number);

    // 逐部分比较主版本号、次版本号、补丁版本号
    for (let i = 0; i < 3; i++) {
      if (onlineParts[i] > localParts[i]) {
        return true; // 线上版本更大
      } else if (onlineParts[i] < localParts[i]) {
        return false; // 本地版本更大或相等
      }
    }
    return false; // 版本相等
  };

  useEffect(() => {
    if (window.navigator.standalone) {
      setTimeout(() => {
        getData()
      }, 1000);
    }
  }, [])

  useEffect(() => {
    if (newversion.length > 0 && !localStorage.getItem(newversion) && web_forceupdate) {
      localStorage.setItem([newversion], newversion)
      const needsUpdate = compareVersions(version, newversion);
      setVisible(needsUpdate)
    }
  }, [newversion, version, web_forceupdate])

  const reload = () => {
    fetch(`/index.html?ts=${new Date().getTime()}`, { cache: 'no-store' })
      .then(response => response.text())
      .then(() => {
        setVersion(packageJson.version);
        window.location.reload(true);
      });
  }

  return (
    <div>
      <Popup
        visible={visible}
        bodyStyle={{
          borderTopLeftRadius: '13px',
          borderTopRightRadius: '13px',
          minHeight: '40vh',
        }}>
        <div style={{ padding: '25px 15px 95px' }}>
          <div style={{
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'baseline',
            position: 'relative',
            left: '30px'
          }}>
            <div style={{ color: '#282828', fontSize: '19px', fontWeight: '500' }}>升级到新版本</div>
            <div style={{ color: '#282828', fontSize: '11px', width: '60px', textAlign: 'left' }}>v{newversion}</div>
          </div>
          <div style={{
            padding: '20px 0',
            fontSize: '14px',
            color: '#666',
            lineHeight: '23px'
          }} dangerouslySetInnerHTML={{ __html: update_content.replace(/([^>\r\n\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2') }}></div>
          <div style={{
            position: 'fixed',
            left: '45px',
            right: '45px',
            bottom: '25px',
          }}>
            <div style={{
              color: '#999',
              fontSize: '12px',
              textAlign: 'center',
              paddingBottom: '5px'
            }}>如在更新或使用中遇到问题，可<NavLink user={false} to='/service'
              onClick={() => setVisible(false)} style={{ color: '#666' }}>联系官方客服</NavLink>处理。</div>
            <div style={{
              backgroundColor: `${BoxColor()}`,
              borderRadius: '25px',
              textAlign: 'center',
              padding: '10px 0',
              fontSize: '16px',
              color: 'white',
            }} onClick={reload}>立即更新</div>
          </div>

        </div>
      </Popup>
    </div>
  )
}
